module.exports = __webpack_public_path__ + "static/media/reedAIaki1028.4bac5291.ico";